import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HongKongCertificate from "../components/assets/images/courses/the hong kong university.png";
import JohnsHopkinsCertificate from "../components/assets/images/courses/johns-hopkins-university.png";
import { SiCplusplus } from "react-icons/si";
import { SiHtml5 } from "react-icons/si";
import { SiCss3 } from "react-icons/si";
import { FaSass } from "react-icons/fa";
import { SiBootstrap } from "react-icons/si";
import { SiJavascript } from "react-icons/si";
import { SiTypescript } from "react-icons/si";
import { SiReact } from "react-icons/si";
import WOW from "wowjs";
import { useEffect } from "react";

const Intro = () => {
  useEffect(() => {
    new WOW.WOW({
      live: true,
    }).init();
  }, []);

  return (
    <Container>
      <section id="intro" className="pt-5 px-5">
        <Row className="mb-5">
          <Col
            id="intro-right"
            lg={6}
            md={6}
            style={{ direction: "rtl" }}
            className="wow animate__animated animate__slideInLeft"
          >
            <h3>CERTIFICATES</h3>
            <div className="d-flex mb-3">
              <a href="https://hkust.edu.hk/" target="_blank" rel="noreferrer">
                <img
                  src={HongKongCertificate}
                  alt="Hong Kong Certificate"
                  className="ms-3 certificates"
                />
              </a>
              <p>
                The Hong Kong University of Science and Technology Course <br />
                Front-End Web Development with React <br />{" "}
                <a
                  href="https://www.coursera.org/account/accomplishments/verify/E7WX4RZTRF4B?utm_campaign=sharing_cta&utm_content=cert_image&utm_medium=certificate&utm_product=course&utm_source=android"
                  target="_blank"
                  rel="noreferrer"
                  className="active"
                >
                  <button className="red-button px-3">Show Credential</button>
                </a>
              </p>
            </div>
            <div className="d-flex mb-3">
              <a href="https://www.jhu.edu/" target="_blank" rel="noreferrer">
                <img
                  src={JohnsHopkinsCertificate}
                  alt="Johns Hopkins Certificate"
                  className="ms-3 certificates"
                />
              </a>
              <p>
                Johns Hopkins University Course <br /> HTML, CSS, and Javascript
                for Web Developers <br />{" "}
                <a
                  href="https://www.coursera.org/account/accomplishments/verify/K9HPB35RDMX3?utm_campaign=sharing_cta&utm_content=cert_image&utm_medium=certificate&utm_product=course&utm_source=android"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="red-button  px-3">Show Credential</button>
                </a>
              </p>
            </div>
          </Col>

          <Col
            lg={6}
            md={6}
            className="wow animate__animated animate__slideInRight"
          >
            <h3>WHO I AM</h3>
            <p>
              Thanks to my life partner Jasmine I became who I am today, through
              her all things were made, without her nothing was made that has
              been made, I'm a frontend web developer from Egypt, I enjoy
              building everything from small business sites to rich interactive
              web apps. I have a serious passion for UI effects, animations and
              creating intuitive and dynamic user experiences. Interested in the
              entire frontend spectrum and working on ambitious projects with
              positive people. If you are a business seeking a web presence or
              an employer looking to hire, you can get in touch with me
            </p>
            <a href="mailto:ahmedm.ishmael@outlook.com">
              <button className="red-button py-2 px-3">Email Me</button>
            </a>
          </Col>
        </Row>
        <div id="spoken-langs">
          <SiCplusplus />
          <SiHtml5 />
          <SiCss3 />
          <FaSass />
          <SiBootstrap />
          <SiJavascript />
          <SiTypescript />
          <SiReact />
        </div>
        <div
          className="d-flex justify-content-center mt-5"
          style={{ width: "100%" }}
        >
          <div className="circle gray"></div>
        </div>
      </section>
    </Container>
  );
};

export default Intro;
